import { cx } from "@emotion/css";
import type { ReactNode } from "react";

type BadgeVariant = "primary" | "success";

interface BadgeProps {
	children: ReactNode;
	className?: string;
	variant?: BadgeVariant;
}

export function Badge({ children, className, variant = "primary" }: BadgeProps) {
	return (
		<span className={cx("badge size-12", `badge--${variant}`, className)}>
			{children}
		</span>
	);
}
